import { createStore } from 'vuex';
import { EventEmitter } from 'events';
import { AuthorizedUser } from '../models/authorized-user';
import snackBarStoreModule from '@/shared/components/snackbar/snack-bar-store-module';
import trustMemberStoreModule from './trust-member-store.module';
import practiceStoreModule from './practice-store-module';
import externalExaminerStoreModule from './external-examiner-store-module';

export default createStore({
  modules: {
    practiceStoreModule,
    trustMemberStoreModule,
    snackBarStoreModule,
    externalExaminerStoreModule,
  },
  state: {
    authorizedUser: new AuthorizedUser(),
    eventController: new EventEmitter(),
  },
  mutations: {
    setUserAccount(state, authorizedUser: AuthorizedUser) {
      state.authorizedUser = authorizedUser;
    },
  },
  actions: { // store.dispatch
    setUserAccount({ commit }, authorizedUser: AuthorizedUser) {
      commit('setAuthorizedUser', authorizedUser);
    }
  },
  getters: {
    getUserAccount: (state) => state.authorizedUser,
    getEventController: (state) => state.eventController,
  }
})
